import { render, staticRenderFns } from "./ExpenseSplittingModal.vue?vue&type=template&id=7b4d8c7d&scoped=true&"
import script from "./ExpenseSplittingModal.vue?vue&type=script&lang=js&"
export * from "./ExpenseSplittingModal.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseSplittingModal.vue?vue&type=style&index=0&id=7b4d8c7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4d8c7d",
  null
  
)

export default component.exports